/**
 * Shared IANA timezone choices for selects (account settings, user working-hours override).
 * First option differs by context — see ACCOUNT_TIMEZONE_OPTIONS vs USER_WORKING_HOURS_TZ_OPTIONS.
 */
const CORE_IANA_TIMEZONES = [
  { value: 'America/New_York', label: 'Eastern (America/New_York)' },
  { value: 'America/Chicago', label: 'Central (America/Chicago)' },
  { value: 'America/Denver', label: 'Mountain (America/Denver)' },
  { value: 'America/Phoenix', label: 'Arizona (America/Phoenix)' },
  { value: 'America/Los_Angeles', label: 'Pacific (America/Los_Angeles)' },
  { value: 'America/Anchorage', label: 'Alaska (America/Anchorage)' },
  { value: 'Pacific/Honolulu', label: 'Hawaii (Pacific/Honolulu)' },
  { value: 'America/Toronto', label: 'Eastern Canada (America/Toronto)' },
  { value: 'America/Vancouver', label: 'Pacific Canada (America/Vancouver)' },
  { value: 'Europe/London', label: 'UK (Europe/London)' },
  { value: 'Europe/Paris', label: 'Central Europe (Europe/Paris)' },
  { value: 'Asia/Kolkata', label: 'India (Asia/Kolkata)' },
  { value: 'Australia/Sydney', label: 'Australia East (Australia/Sydney)' },
  { value: 'UTC', label: 'UTC' },
];

export const ACCOUNT_TIMEZONE_OPTIONS = [
  { value: '', label: '— Use server default —' },
  ...CORE_IANA_TIMEZONES,
];

/** Empty value: use organization or device time zone when interpreting custom hours (server behavior). */
export const USER_WORKING_HOURS_TZ_OPTIONS = [
  { value: '', label: '— Organization or device time zone —' },
  ...CORE_IANA_TIMEZONES,
];

/**
 * Human-readable label for a stored value (matches TimezoneSelect option wording).
 * @param {string} [value] - IANA id or empty
 * @param {'account'|'user'} [variant='user']
 */
export function timezoneDisplayLabel(value, variant = 'user') {
  const opts = variant === 'account' ? ACCOUNT_TIMEZONE_OPTIONS : USER_WORKING_HOURS_TZ_OPTIONS;
  const v = value != null ? String(value).trim() : "";
  if (!v) {
    return variant === "account" ? "Server default" : "Organization or device";
  }
  const opt = opts.find((o) => o.value === v);
  if (!opt) return v;
  return String(opt.label)
    .replace(/^[-\u2014]\s*/, "")
    .replace(/\s*[-\u2014]\s*$/, "")
    .trim();
}
